import React from 'react'

const ProcurementAnalysis = () => {
  return (
    <div className='mx-auto p-4'>
      ProcumentAnalysis
    </div>
  )
}

export default ProcurementAnalysis
